$(document).ready(function () {
    const cartItemsElement = document.querySelector('cart-items');
    setTimeout(function () {
        $('.atc-complementary').on('click', function () {
            var productId = $(this).data('id');
            var cartUrl = '/cart';
            var data = {
                items: [{
                    id: productId,
                    quantity: 1
                }]

            };
            console.log(data);
            addToCart(productId, 1, cartUrl);
        });
    }, 1000);


    function addToCart(variantId, quantity = 1, cartUrl) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => {
                        throw new Error(error.description);
                    });
                } else {
                    // window.location.href = cartUrl;
                    if (cartItemsElement) {
                        cartItemsElement.updateQuantity(1, 1);
                    }
                }
                return response.json();
            })
            .then(data => {
            })
            .catch(error => {
                console.error('Error adding variant to cart:', error.message);
            });
    }
});
